export const OPEN_DRAWER = "OPEN_DRAWER";
export const CLOSE_DRAWER = "CLOSE_DRAWER";
export const TOGGLE_CUSTOM_DOMAIN = "TOGGLE_CUSTOM_DOMAIN";
export const TOGGLE_STRATIFICATION = "TOGGLE_STRATIFICATION";
export const TOGGLE_CUSTOM_DOMAIN_COMPARISON = "TOGGLE_CUSTOM_DOMAIN_COMPARISON";
